import clsx from 'clsx';
import React from 'react';

import styles from './image-filled.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  src: string;
  width?: number;
  height?: number;
  borderRadius?: number;
  ariaLabel?: string;
  alt?: string;
}

const ImageFilled = (props: Props) => {
  const { ariaLabel, borderRadius, className, height, src, style, width, ...rest } = props;
  if (!src) {
    return null;
  }

  return (
    <div
      aria-label={ariaLabel}
      className={clsx(styles['image-filled'], className)}
      style={{
        ['--image-filled-src' as string]: `url(${src})`,
        ['--image-filled-width' as string]: width ? `${width}px` : undefined,
        ['--image-filled-height' as string]: height ? `${height}px` : undefined,
        ['--image-filled-border-radius' as string]: borderRadius ? borderRadius : undefined,
        ...style
      }}
      {...rest}
    />
  );
};

export default ImageFilled;
